<script>
import MainContainer from '@/components/main/MainContainer.vue'

export default {
	name: 'QaBlock',
	components: {
		MainContainer,
	},
	data() {
		return {
			isActive: false,
		}
	},
}
</script>

<template>
	<section class="pb-[20px] lg:py-[40px]">
		<MainContainer
			class="relative flex flex-col items-stretch gap-x-[55px] gap-y-[10px] md:flex-row md:justify-between"
		>
			<div
				class="group relative bg-[#F2D04C] rounded-[45px] py-[50px] px-[44px] pb-[305px] w-full md:py-[60px] lg:py-[85px] lg:px-[77px] md:max-w-[639px]"
			>
				<img
					src="@/assets/img/main/fisher-real.png"
					alt=""
					class="max-w-[280px] right-[50%] duration-700 transform translate-x-1/2 absolute bottom-0 md:right-[-8%] md:translate-x-0 md:w-[59%] md:max-w-none group-hover:scale-110 group-hover:translate-y-[-5%] group-hover:translate-x-[45%] md:group-hover:translate-x-[-5%]"
				/>
				<div class="relative z-1 md:max-w-[292px]">
					<div class="font-main font-extrabold text-[24px] text-dark leading-7 mb-[20px]">
						{{ $t('titles.start_using') }}
					</div>
					<div class="font-main font-normal text-[16px] text-dark leading-6 mb-[30px]">
						{{ $t('titles.need_ecp') }}
					</div>

					<router-link
						:to="`/${$i18n.locale}/registration`"
						class="w-full !w-[218px] text-center inline-block border-[2px] border-dark rounded-[45px] px-[20px] py-[30px] cursor-pointer bg-transparent font-semibold text-[16px] duration-700 group-hover:no-underline group-hover:!bg-dark group-hover:!text-[#FFF]"
					>
						{{ $t('commands.sign_in') }}
					</router-link>
				</div>
			</div>

			<div class="w-full flex flex-col gap-[17px] md:max-w-[424px]">
				<div
					class="relative overflow-hidden rounded-[45px] bg-white flex flex-col items-start justify-center pl-[34px] pr-[35px] h-[191px] lg:pl-[74px]"
				>
					<div
						class="absolute top-[-32px] right-[-24px] w-[93px] h-[93px] rounded-full bg-[#157fee]"
					></div>
					<router-link
						:to="`/${$i18n.locale}/faq`"
						class="block absolute z-1 top-[18px] right-[22px] cursor-pointer"
					>
						<img src="@/assets/svgs/link-arrow-circle-right.svg" alt="" class="block" />
					</router-link>
					<div
						class="inline-flex items-center gap-[10px] mb-[5px] font-main font-extrabold text-[18px] leading-6 text-second lg:text-[24px]"
					>
						<img src="@/assets/svgs/message-question.svg" alt="" />
						<span>{{ $t('titles.faq') }}</span>
					</div>
					<div class="font-main font-normal text-[16px] text-second">
						{{ $t('titles.faq_list') }}
					</div>
				</div>

				<div
					class="relative overflow-hidden rounded-[45px] bg-white flex flex-col items-start justify-center pl-[34px] pr-[35px] h-[191px] lg:pl-[74px]"
				>
					<div
						class="absolute top-[-32px] right-[-24px] w-[93px] h-[93px] rounded-full bg-[#157fee]"
					></div>
					<div
						class="block absolute z-1 top-[18px] right-[22px] cursor-pointer"
						@click="isActive = true"
					>
						<img src="@/assets/svgs/link-arrow-circle-right.svg" alt="" class="block" />
					</div>
					<div
						class="inline-flex items-center gap-[10px] mb-[5px] font-main font-extrabold text-[18px] leading-6 text-second lg:text-[24px]"
					>
						<img src="@/assets/svgs/video-play.svg" alt="" />
						<span>{{ $t('titles.video_inst') }}</span>
					</div>
					<div class="font-main font-normal text-[16px] text-second">
						{{ $t('titles.how_work_video_inst') }}
					</div>
				</div>

				<div
					v-if="isActive"
					class="fixed z-[1100] top-0 left-0 right-0 bottom-0 flex justify-center items-center bg-[#000000ec]"
					@click.stop="isActive = false"
				>
					<div class="relative box-border w-[90%] max-w-[880px] box-border">
						<div class="w-full box-border aspect-w-8 aspect-h-5 rounded-[45px] overflow-hidden">
							<iframe
								src="https://www.youtube.com/embed/zKq2YXtIBNc?si=8j1kVTe1GHQxMx0_"
								title="YouTube video player"
								frameborder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
								referrerpolicy="strict-origin-when-cross-origin"
								allowfullscreen
							></iframe>
						</div>
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'absolute top-[-45px] right-1/2 transform -translate-x-1/2 block w-[24px] h-[24px] z-[100] cursor-pointer'" @click="isActive = false" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M3 21L21 3M21 21L3 3" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
					</div>
				</div>
			</div>
		</MainContainer>
	</section>
</template>

<style scoped>
.text-decoration-thickness {
	text-decoration-thickness: 1px;
}
</style>
